define(
    'utils/View',['jquery'],

    function () {
        return function (viewName, callback) {
            if ($('[data-view="' + viewName + '"]').length) {
                return callback;
            }

            return function () {};
        };
    }
);
